export default __webpack_public_path__ + "static/media/Chhatt_health_m.9cb4c76b.wav";